import React, { useState, useRef } from 'react';
import { ControlButton } from '../UIGameReplayControls/ReplayControlsContent/ControlButton/index.ts';
import { Spinner } from '@colonist/ui';
import IconShare from '@static/images/icon_share.svg';
export const GameResultsControlsShareButton = ({ onShare, spinnerClassName })=>{
    const [isLoading, setIsLoading] = useState(false);
    const timeoutRef = useRef(null);
    const handleShare = ()=>{
        if (timeoutRef.current) return;
        onShare();
        setIsLoading(true);
        timeoutRef.current = setTimeout(()=>{
            setIsLoading(false);
            timeoutRef.current = null;
        }, 1500);
    };
    if (isLoading) return /*#__PURE__*/ React.createElement(Spinner, {
        className: spinnerClassName
    });
    return /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconShare,
        alt: "strings:imgAlts.Share",
        onClick: handleShare,
        disableTooltip: true
    });
};
